import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLogout } from 'react-admin';
import { UserRole } from '../types/types';
import authProvider from '../auth/authProvider';
import { isTokenExpired } from '../utils/jwtUtils';

const useAuthorize = (allowedRoles: UserRole[]) => {
  const navigate = useNavigate();
  const logout = useLogout();

  useEffect(() => {
    const token = localStorage.getItem('user_authToken');

    if (!token || isTokenExpired(token)) {
      logout();
      return;
    }

    if (!authProvider.isRoleAuthorized(allowedRoles)) {
      navigate('/not-authorized', { replace: true });
    }
  }, [allowedRoles, navigate, logout]);
};

export default useAuthorize;
